import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useConsumiNetSales from '../useConsumiNetSales';
import BarChangeChart from '../../../charts/barChange';
import AlertMessage from '../../../components/alertMessage';
import UIHelper from '../../../../../helpers/UIHelper';

const MainPage = () => {
  const {
    data,
    columns,
    columns2,
    filters,
    format,
    title,
    loading,
    handleDownloadExcel,
    summary,
    summary2,
    searchParams,
    loadingPdf,
    handleDownloadPdf,
    errors,
  } = useConsumiNetSales();
  const { t } = useTranslation();
  return (
    <>
      <PageHeader title={t('Sales by Category / Sales').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        <AlertMessage errors={errors} searchParams={searchParams} />
        <Spin spinning={loading}>
          <Row className={styles.titleSection} justify={'center'}>
            <Col>
              <Typography.Title level={3}>{title}</Typography.Title>
            </Col>
          </Row>
          <Row>
            <Col xxl={12} xs={24}>
              <Row>
                <Col span={24}>
                  <Table
                    loading={loading}
                    columns={UIHelper.assignTire(columns)}
                    dataSource={data.table1}
                    pagination={{
                      pageSize: 10000,
                      position: ['bottomCenter'],
                      hideOnSinglePage: true,
                      showSizeChanger: false,
                    }}
                    bordered
                    summary={summary}
                    scroll={{ x: 1500 }}
                  />
                </Col>
                <Divider />
                <Col span={24}>
                  <Table
                    loading={loading}
                    columns={UIHelper.assignTire(columns2)}
                    dataSource={data.table2}
                    pagination={{
                      pageSize: 10000,
                      position: ['bottomCenter'],
                      hideOnSinglePage: true,
                      showSizeChanger: false,
                    }}
                    bordered
                    summary={summary2}
                    scroll={{ x: 1500 }}
                  />
                </Col>
              </Row>
            </Col>
            <Col xxl={12} xs={24}>
              <BarChangeChart
                keys={['Inc. % Net Sales YTD', 'Inc. % Net Sales LY']}
                data={data}
                format={format}
                lineItemWidth={150}
                itemWidth={150}
                translateX={230}
              />

              <br />
              <BarChangeChart
                keys={['Inc. % Net Sales YTD', 'Inc. % Net Sales LY']}
                data={data.bar2}
                format={format}
                lineItemWidth={150}
                itemWidth={150}
                translateX={230}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default MainPage;
